import { useEffect, useState } from "react";
import { BsPencil } from "react-icons/bs";
import { formatDateTimeEsCO } from "../../../helpers";
import { usePatientSurgeryStore } from "../../hooks";
import { LoadingData, ErrorMessage, SuccessMessage } from "../../ui";
import { translationsPatientSurgeryState } from "../../data";
import { ModifyProtocolModal } from "../modals";
import { translations } from "../../../helpers";
import { Pagination } from "../navigation";

export const PatientSurgeryTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgeries,
    patientSurgery,
    filters,
    pagination,

    // Methods
    getPatientSurgery,
  } = usePatientSurgeryStore();
  // States ------------------------------------------------//
  const [showModal, setShowModal] = useState(false);
  const [selectedPatientSurgery, setSelectedPatientSurgery] = useState(null);
  const [page, setPage] = useState(1);
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const openModal = (patientSurgery) => {
    setSelectedPatientSurgery(patientSurgery);
    setShowModal(true);
  };
  // Efectos -----------------------------------------------//
  const { pageSize } = pagination;

  useEffect(() => {
    getPatientSurgery({
      filters,
      pagination: { page, pageSize },
    });
  }, [page, pageSize, filters, getPatientSurgery]);

  useEffect(() => {
    setPage(1);
  }, []);

  return (
    <>
      {patientSurgeries.isLoading && <LoadingData />}
      {(patientSurgeries.message?.type === "error" ||
        patientSurgery.message?.type === "error") && (
        <ErrorMessage>
          {patientSurgeries.message.text || patientSurgery.message.text}
        </ErrorMessage>
      )}
      {patientSurgery.message?.type === "success" && (
        <SuccessMessage>
          {translations[patientSurgery.message.text]}
        </SuccessMessage>
      )}

      <div className="table-responsive shadow rounded">
        <table className="table table-borderless">
          <thead>
            <tr>
              <th>Nombres</th>
              <th>Apellidos</th>
              <th>Procedimiento</th>
              <th>Fecha</th>
              <th>Riesgo</th>
              <th>Estado</th>
              <th>Modificar valoración</th>
            </tr>
          </thead>
          <tbody>
            {patientSurgeries.data.map((patientSurgery) => {
              const { firstName, lastName } = patientSurgery.patient.user;
              const { title } = patientSurgery.procedure.procedure;
              const { start } = patientSurgery.scheduleEvents?.[0];
              const { createdAt, track, state } = patientSurgery;

              return (
                <tr key={patientSurgery.id}>
                  <td className="py-3">{firstName}</td>
                  <td className="py-3">{lastName}</td>
                  <td className="py-3">{title}</td>
                  <td className="py-3">
                    {formatDateTimeEsCO(start) || "PENDIENTE"}
                  </td>
                  <td className="py-3">
                    <h6>
                      <span className="badge bg-light text-dark">
                        {track || "PENDIENTE"}
                      </span>
                    </h6>
                  </td>
                  <td className="py-3">
                    {translationsPatientSurgeryState[state] || state}
                  </td>
                  <td className="py-3">
                    {(state === "ASSESSMENT_MADE" || state === "FINISHED" || state === "ASSESSMENT_MADE_RESCHEDULE") && (
                      <button
                        to="#"
                        className="btn btn-icon btn-pills btn-soft-primary"
                        onClick={() => openModal(patientSurgery)}
                      >
                        <BsPencil />
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Pagination
        page={page}
        setPage={setPage}
        pageSize={15}
        totalPages={patientSurgeries.data.length}
      />
      <>
        {showModal && (
          <ModifyProtocolModal
            isOpen={showModal}
            setIsOpen={setShowModal}
            patientSurgery={selectedPatientSurgery}
          />
        )}
      </>
    </>
  );
};
